import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query'
import { registerTemplateKeys } from '../registerTemplateKeys'
import { RequestTypes } from '../requestTypes'
import { RequestErrorType } from '@core/utils/api-axios-instance'

type ImportPropertiesResponse = { propertyIds: number[] }

export const useImportRegisterTemplateProperties = (
  options?: UseMutationOptions<
    ImportPropertiesResponse,
    RequestErrorType,
    RequestTypes['importRegisterTemplateProperties']
  >,
) => {
  const queryClient = useQueryClient()
  return useMutation<
    ImportPropertiesResponse,
    RequestErrorType,
    RequestTypes['importRegisterTemplateProperties']
  >({
    ...registerTemplateKeys.importRegisterTemplateProperties,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: registerTemplateKeys._def })
    },
    ...options,
  })
}
